export default function downloadFile(content, filename) {
  const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${content}`
  const downloadLink = document.createElement('a')
  downloadLink.download = filename
  downloadLink.href = linkSource
  downloadLink.target = '_blank'
  downloadLink.click()
}
